import React, { useContext, useEffect, useState } from 'react';
import {
  RequestClaimsContainerStyled,
  RequestClaimsContentStyled,
  RequestClaimsHeaderStyled,
  SkeletonTitle,
  SkeletonSubtitle,
  SkeletonActionButton,
  SkeletonRequestClaimsContainer,
  SkeletonMoreText,
  SkeletonMoreIcon,
} from './styles/RequestClaimsStyled';
import { ActionButtonStyled } from '../styles/HelpStyled';

import RequestClaimsService from '../../../services/RequestAndClaims';
import SmsPremiumService from '../../../services/SmsPremium';
import { redirectInternalOrExternal } from '../../../helpers/Redirect';
import { GoogleTagManager } from '../../../helpers';
import AppContext from '../../App/AppContext';

const onActionButtonClick = (title, url) => {
  GoogleTagManager.tagInteractiveEvent({
    eventCategory: 'Ayuda',
    eventAction: `Presionar Botón - Solicitudes y reclamos - ${title}`,
    eventTag: `Ayuda - ${title}`,
  });
  redirectInternalOrExternal(url);
};

const RequestClaims = () => {
  const [actionButtons, setActionButtons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { setSmsPremiumServices } = useContext(AppContext);

  const fetchActionButtons = () =>
    Promise.allSettled([
      RequestClaimsService.getReqAndClaims(),
      SmsPremiumService.getProfile(),
    ]).then(([reqAndClaims, smsPrem]) => {
      const [{ items }] = reqAndClaims.value;
      if (smsPrem.status !== 'fulfilled' || smsPrem.value[0].statusCode !== 0) {
        return items.filter(({ title }) => title !== 'Otras suscripciones');
      }
      if (
        smsPrem?.value[0]?.statusCode === 0 &&
        smsPrem?.value[0]?.profile?.length > 0
      )
        setSmsPremiumServices(smsPrem.value[0].profile);
      else setSmsPremiumServices(null);

      return items;
    });

  useEffect(() => {
    fetchActionButtons()
      .then(items => {
        setActionButtons(items);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <RequestClaimsContainerStyled>
        <RequestClaimsHeaderStyled>
          <SkeletonTitle />
          <SkeletonSubtitle />
        </RequestClaimsHeaderStyled>
        <RequestClaimsContentStyled>
          <SkeletonActionButton />
          <SkeletonActionButton />
          <SkeletonActionButton />
        </RequestClaimsContentStyled>
        <SkeletonRequestClaimsContainer>
          <SkeletonMoreText />
          <SkeletonMoreIcon />
        </SkeletonRequestClaimsContainer>
      </RequestClaimsContainerStyled>
    );

  if (error || actionButtons.length === 0) return null;

  return (
    <RequestClaimsContainerStyled>
      <RequestClaimsHeaderStyled>
        <h1>Solicitudes y reclamos</h1>
        <h2>Gestiona o reporta problemas según tu caso</h2>
      </RequestClaimsHeaderStyled>
      <RequestClaimsContentStyled>
        {actionButtons.map(({ title, icon, url, new: isNew }, index) => (
          <ActionButtonStyled
            upperTitle={title}
            key={title}
            icon={() => <img src={icon.url} alt={title} />}
            centerbutton={
              index + 1 === actionButtons.length && index % 3 === 0 ? 1 : 0
            }
            onClick={() => onActionButtonClick(title, url)}
            $isNew={isNew}
          />
        ))}
      </RequestClaimsContentStyled>
    </RequestClaimsContainerStyled>
  );
};

export default RequestClaims;
